/* Filename: custom-progress.js
   Replacement JS for custom-progress carousel.
   - Pagination skips 'skip' slides per dot (configurable)
   - Arrows move by 1 slide
   - Percentage-based translateX, responsive visibleCount
   - Touch & mouse drag; keyboard nav
   - All classes use custom-progress- prefix
*/

(function () {
  'use strict';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  function initCarousel(root) {
    const track = $('.custom-progress-track', root);
    const slides = $all('.custom-progress-slide', root);
    const prevBtn = $('.custom-progress-prev', root);
    const nextBtn = $('.custom-progress-next', root);
    const pagination = $('.custom-progress-pagination', root);
    const wrap = $('.custom-progress-track-wrap', root);

    if (!track || slides.length === 0) return;

    // CONFIG: how many slides to skip per pagination button
    const skip = 2;

    let currentIndex = 0;     // left-most visible slide index
    let visibleCount = 1;     // slides visible at once
    let pageTargets = [];     // array of indices each pagination dot targets

    // Compute visibleCount from computed flex-basis or wrapper width
    function computeVisibleCount() {
      // try reading flex-basis percent from computed style
      const cs = window.getComputedStyle(slides[0]);
      const flexBasis = cs.getPropertyValue('flex-basis') || cs.flexBasis || '';
      const m = flexBasis.match(/([\d.]+)%/);
      if (m) {
        const percent = parseFloat(m[1]);
        if (percent > 0) {
          visibleCount = Math.max(1, Math.round(100 / percent));
          visibleCount = Math.min(visibleCount, slides.length);
          return;
        }
      }
      // fallback: container width / slide width
      const wrapW = Math.max(1, wrap.getBoundingClientRect().width);
      const slideW = Math.max(1, slides[0].getBoundingClientRect().width);
      visibleCount = Math.max(1, Math.floor(wrapW / slideW));
      visibleCount = Math.min(visibleCount, slides.length);
    }

    // Build the list of pagination targets (indices). We step by `skip`, but ensure
    // last target shows the last slides (slides.length - visibleCount).
    function buildPageTargets() {
      const targets = new Set();
      //const skip = 2;
      for (let i = 0; i < slides.length; i += skip) {
        const t = Math.min(i, Math.max(0, slides.length - visibleCount));
       // const t = Math.min(i, slides.length - visibleCount);
        targets.add(t);
      }
      // ensure the last possible index is present
      targets.add(Math.max(0, slides.length - visibleCount));
      pageTargets = Array.from(targets).sort((a,b)=>a-b);
    }

    // Build pagination buttons based on pageTargets
    function buildPagination() {
      if (!pagination) return;
      pagination.innerHTML = '';
      pageTargets.forEach((target, idx) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-label', 'Go to slide group ' + (idx + 1));
        btn.setAttribute('data-target', String(target));
        btn.addEventListener('click', () => goTo(target));
        pagination.appendChild(btn);
      });
      updatePagination();
    }

    // Update aria-selected on pagination to reflect currentIndex
    function updatePagination() {
      if (!pagination) return;
      const btns = $all('button', pagination);
      btns.forEach(b => {
        const t = parseInt(b.getAttribute('data-target'), 10);
        b.setAttribute('aria-selected', String(t === currentIndex));
      });
    }

    // Compute and apply translate percent
  function setPosition() {
  const maxIndex = Math.max(0, slides.length - visibleCount);
  if (currentIndex < 0) currentIndex = 0;
  if (currentIndex > maxIndex) currentIndex = maxIndex;

  const stepPercent = getStepPercent();      // ← use real slide+gap width
  const translatePercent = -(currentIndex * stepPercent);
  track.style.transform = `translateX(${translatePercent}%)`;
  updatePagination();
}





    function getStepPercent() {
  const wrapW = wrap.getBoundingClientRect().width || 1;
  const first = slides[0].getBoundingClientRect();
  const second = slides[1] ? slides[1].getBoundingClientRect() : null;
  const slideWidth = first.width;
  const gapPx = second ? (second.left - first.right) : 0; // actual gap between slides
  return ((slideWidth + gapPx) / wrapW) * 100;
}




    // Navigate
    function goTo(index) {
      const maxIndex = Math.max(0, slides.length - visibleCount);
      currentIndex = Math.min(Math.max(0, index), maxIndex);
      setPosition();
    }
    function prev() { goTo(currentIndex - skip); }
    function next() { goTo(currentIndex + skip); }

    // Drag support (percent-based)
    let dragging = false;
    let startX = 0;
    let startTranslatePercent = 0;

    function getCurrentTranslatePercent() {
      const style = window.getComputedStyle(track);
      const t = style.transform;
      if (!t || t === 'none') return 0;
      // matrix(a, b, c, d, tx, ty)
      const mat = t.match(/matrix\((.+)\)/);
      if (!mat) return 0;
      const parts = mat[1].split(',').map(s => parseFloat(s.trim()));
      const tx = parts[4] || 0; // px
      const wrapW = wrap.getBoundingClientRect().width || 1;
      return (tx / wrapW) * 100;
    }

    function onDown(e) {
      dragging = true;
      startX = e.touches ? e.touches[0].clientX : e.clientX;
      startTranslatePercent = getCurrentTranslatePercent();
      track.style.transition = 'none';
    }
    function onMove(e) {
      if (!dragging) return;
      const x = e.touches ? e.touches[0].clientX : e.clientX;
      const dx = x - startX;
      const wrapW = wrap.getBoundingClientRect().width || 1;
      const dxPercent = (dx / wrapW) * 100;
      track.style.transform = `translateX(${startTranslatePercent + dxPercent}%)`;
      e.preventDefault && e.preventDefault();
    }

    
 // 2) In onUp()
function onUp(e) {
  if (!dragging) return;
  dragging = false;
  track.style.transition = '';

  const x = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
  const dx = x - startX;
  const wrapW = wrap.getBoundingClientRect().width || 1;
  const movedPercent = (dx / wrapW) * 100;

  const stepPercent = getStepPercent();      // ← use same helper
  const threshold = stepPercent * 0.2;

  if (movedPercent < -threshold) {
    currentIndex = Math.min(currentIndex + skip, slides.length - visibleCount);
  } else if (movedPercent > threshold) {
    currentIndex = Math.max(currentIndex - skip, 0);
  }
  setPosition();
}


    // keyboard navigation
    root.addEventListener('keydown', (ev) => {
      if (ev.key === 'ArrowLeft') prev();
      if (ev.key === 'ArrowRight') next();
    });

    // Wire up UI events
    prevBtn && prevBtn.addEventListener('click', prev);
    nextBtn && nextBtn.addEventListener('click', next);

    track.addEventListener('touchstart', onDown, {passive:true});
    track.addEventListener('touchmove', onMove, {passive:false});
    track.addEventListener('touchend', onUp);
    track.addEventListener('mousedown', onDown);
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);

    // Recompute and rebuild on resize
    let rt;
    function onResize() {
      clearTimeout(rt);
      rt = setTimeout(() => {
        computeVisibleCount();
        buildPageTargets();
        buildPagination();
        // clamp
        currentIndex = Math.max(0, Math.min(currentIndex, slides.length - visibleCount));
        setPosition();
      }, 90);
    }
    window.addEventListener('resize', onResize);

    // Initial setup
    function init() {
      // Wait for layout/images to settle
      requestAnimationFrame(() => {
        computeVisibleCount();
        buildPageTargets();
        buildPagination();
        setPosition();
      });
    }
    init();

    // Return small API if needed
    return {
      goTo, next, prev, refresh: onResize
    };
  }

  // Auto-init on DOM ready
  document.addEventListener('DOMContentLoaded', function () {
    const roots = $all('.custom-progress-carousel');
    roots.forEach(r => initCarousel(r));
  });

})();
